import React, { use, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import api from "services/api";
import Breadcrumbs from "components/common/Breadcrumbs";
import styles from "./SingleProgrammePage.module.css";
import SpectacleDetailSummary from "components/common/SpectacleDetailSummary";
import archiveStyle from "styles/modules/Archives.module.css";
import Accessible from 'assets/images/accessible.png';
import SpectacleDetailGallery from "components/common/SpectacleDetailGallery";
import SpectacleDetailVideo from "components/common/SpectacleDetailVideo";
import SpectacleDetailExtra from "components/common/SpectacleDetailExtra";
import Spinner from "components/common/Spinner";
import { Helmet } from "react-helmet";
import Page404 from "./Page404";

const SpectaclesPage = () => {
  const { spectacleSlug } = useParams();
  const [loading, setLoading] = useState(true);
  const [spectacle, setSpectacle] = useState([]);


  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);

  useEffect(() => {
    const handleResize = () => {
      window.requestAnimationFrame(() => {
        setIsMobile(window.innerWidth <= 991);
      });
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  useEffect(() => {
    setLoading(true);
    setSpectacle([]);
    const fetchSpectacleData = async () => {
      try {
        const response = await api.get(`/spectacles/details/${spectacleSlug}`);
        const spectacle = response.data[0];
        setSpectacle(spectacle);
      } catch (error) {
        console.error("Erreur lors de la récupération des données du spectacle ou concert :", error);
      } finally {
        setLoading(false);
      }
    };
    fetchSpectacleData();
  }, [spectacleSlug]);



  const Galerie = spectacle?.galleryImages || [];

  // Charger plus de pages
  //const loadMore = () => setDisplayCount((prevCount) => prevCount + 6);

  if (loading) return <div className="page-content section-no-padding">
    <section className={`global-section global-section-title ${styles.section}`} style={{ minHeight: '100vh', paddingTop: 200 }}>
      <Spinner />
    </section>
  </div>;
  if (!spectacle || !spectacle.typeShow) return <Page404 />;

  return (
    <>
      <Helmet>
        <title>{spectacle.name} - Pharos</title>
        <meta name="description" content={spectacle.description || "Découvrez les détails de ce spectacle ou concert."} />
        <meta property="og:title" content={`${spectacle.name} - Pharos`} />
        <meta property="og:description" content={spectacle.description || "Découvrez les détails de ce spectacle ou concert."} />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className={`page-content section-no-padding ${styles.pageContent}`}>
        <section className={`global-section global-section-title ${styles.section}`}>
          <div className={`global-container ${styles.content} ${spectacle?.typeShow?.code === 'concert' ? styles.concert : ""}`}>
            <div className={archiveStyle.header}>
              {/* Fil d'Ariane */}
              {['spectacle', 'concert'].includes(spectacle?.typeShow?.code) && (
                <Breadcrumbs
                  pageType={spectacle.typeShow.code === 'concert' ? 'isConcert' : 'isSpectacle'}
                  element={{ title: spectacle.name }}
                />
              )}
            </div>
          </div>
        </section>
        <section className={`global-section ${styles.section}`}>
          <div className={`global-container ${styles.content}`}>
            {/* Liste des pages ou message d'absence */}
            {spectacle ? (
              <>
                <div className={styles.spectacleDetail}>
                  <div className={styles.spectacleDetailLeft}>
                    <div className={styles.spectacleDetailImage}>
                      {spectacle.poster && <img src={spectacle.poster.path} alt={`Affiche du ${spectacle?.typeShow?.code === 'concert' ? 'concert' : 'spectacle'} ${spectacle.name}`} className={styles.image} />}
                    </div>
                    {!isMobile && <div className={styles.Accessibility}>
                      <span className={styles.sectionTitle}>Accessibilité</span>
                      {spectacle?.lieu?.pictoAccessibilite && (
                        <div dangerouslySetInnerHTML={{ __html: spectacle.lieu.pictoAccessibilite }} aria-label="Informations d'accessibilité du lieu" />
                      )}
                    </div>}



                  </div>
                  <div className={styles.spectacleDetailRight}>
                    <SpectacleDetailSummary loading={loading} details={spectacle} />
                  </div>

                </div>
                <div className={`${styles.spectacleDetail} ${styles.galerieContainer}`}>
                  {!isMobile && spectacle.video && <div className={styles.spectacleDetailLeft}>
                    <SpectacleDetailVideo video={spectacle.video} thumb={spectacle?.poster.path} />
                  </div>}
                  <div className={styles.spectacleDetailRight}>
                    <SpectacleDetailGallery Galerie={Galerie} />
                  </div>
                </div>
                {isMobile && <div className={styles.Accessibility}>
                  <h2 className={styles.sectionTitle}>Accessibilité</h2>
                  {spectacle?.lieu?.pictoAccessibilite && (
                    <div dangerouslySetInnerHTML={{ __html: spectacle.lieu.pictoAccessibilite }} aria-label="Informations d'accessibilité du lieu" />
                  )}
                </div>}
              </>
            ) : (
              <p>Aucune page trouvée pour ce concert ou spectacle.</p>
            )}
          </div>
          <div className={`global-container`}>
            <SpectacleDetailExtra categorieId={spectacle?.typeShow.code} excludedEventSlug={spectacleSlug} />
          </div>
        </section >
      </div >
    </>
  );
};

export default SpectaclesPage;
